import React from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";
import Study from "./pages/Study";
import NoteDetail from "./pages/NoteDetail";
import Paintings from "./pages/Paintings";
import TheCat from "./pages/TheCat";
import AboutMe from "./pages/AboutMe";
import Admin from "./pages/Admin";
import AdminEdit from "./pages/AdminEdit";

function AppInner() {
  const { dark } = useTheme();
  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${
        dark ? "bg-gray-900 text-white" : "bg-stone-50 text-gray-900"
      }`}
    >
      <Sidebar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/study" element={<Study />} />
        <Route path="/study/:slug" element={<NoteDetail />} />
        <Route path="/paintings" element={<Paintings />} />
        <Route path="/thecat" element={<TheCat />} />
        <Route path="/aboutme" element={<AboutMe />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/edit/:slug" element={<AdminEdit />} />
        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen text-gray-400 text-lg">
              Page not found
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppInner />
    </ThemeProvider>
  );
}
